import { memo, useState,useContext } from "react"
import Chips from "../../../../../../library/Chips/Chips"

import { MyContextHoldem } from '../CasinoHoldem';
const CasinoholdemGameControllers = memo((props) => {

    const {selectedChip, setChipCount} = useContext(MyContextHoldem);
  const{Enableclick, setEnableclick}= useContext(MyContextHoldem);
    return <>
        <div className="paiGowChipsBoxholdem">
            <button className="chipArrowsholdem" disabled={selectedChip === 0 || Enableclick} onClick={() => {
                if (selectedChip >= 1) {
                    props?.playChipSound();
                    setChipCount((prevState) => prevState - 1);
                }
            }}>
            </button>
            <div className="chipsBoxholdem">
                <div className="allChipsholdem" style={{ "--selectedIndex":selectedChip }}>
                    <Chips selectedChipIndex={selectedChip} 
                    
                        chipWidth="150"
                        chipHeight="150"
                    
                        chipSelectionFn={(_, index) => {
                            window.innerHeight > window.innerWidth && props?.playChipSound();
                            setChipCount(index);
                        }}
                    
                    gameChips={props.chipsArray} />
                </div>
            </div>
            <button className="chipArrowsholdem rightArrowholdem" 
            disabled={selectedChip === props.chipsArray.split(",").length - 1 || Enableclick} 
            // onClick={() => {selectedChip < props.chipsArray.split(",").length - 1 && setChipCount((prevState) => prevState + 1) }}
              onClick={() => {
                if (selectedChip < props.chipsArray.split(",").length - 1) {
                    props?.playChipSound();
                    setChipCount((prevState) => prevState + 1);
                }
            }}
            
            >
            </button>
        </div>
    </>
})

export default CasinoholdemGameControllers